import React from "react";
import ActualSalesSummary from '../components/actualSalesSummary'

const ActualSalesSummaryPage = () => {
    return (
        <>
            <ActualSalesSummary />
        </>
    );
};

export default ActualSalesSummaryPage;
